import React from 'react';
//import DataForm from './DataForm';
import './formData.css';
import NeetoCalEmbed from './NeetoCalEmbed';
import { useTranslation } from 'react-i18next';

function FormBooking() {

    const { t } = useTranslation();

    return (            
        <section className='sec--area mt-5 form-booking' id='Formulario'>
            <div className="container">
                <div className="row">
                    <div className='col-lg-4 colum-1'>
                        <h3 className='w_color f--size-50 f_600'>{t("form_booking_title")}</h3>
                        <p className='w_color'>info@dreamcodesoft.com</p>
                        </div>
                    <div className='col-lg-8 colum-2'>
                        <div className="dataform" >
                            {/* <DataForm /> */}
                            <NeetoCalEmbed />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default FormBooking;